/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Restore checkpoint?" |
*
* @param {Assistant_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_title = /** @type {((inputs?: Assistant_Restore_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer le point de contrôle ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellungspunkt wiederherstellen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristinare il checkpoint?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить контрольную точку?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Restaurar punto de control?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复检查点？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チェックポイントを復元しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चेकपॉइंट पुनर्स्थापित करें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar ponto de verificação?")
	return /** @type {LocalizedString} */ ("Restore checkpoint?")
});